import React from 'react';
import { fmtValue } from '../format';
import StatusPill from './StatusPill';

const NUMERIC = ['money', 'number', 'integer'];

// compact table over a resource's list columns (or the named ones), as Stephanet's MiniTable
export default function MiniTable({ res, rows, columns, onRow, empty = 'Nothing here' }) {
  const cols = columns
    ? columns.map(n => res.fields.find(f => f.name === n)).filter(Boolean)
    : res.fields.filter(f => f.list && f.name !== 'employee_id').slice(0, 7);
  if (!rows.length) return <div className="empty">{empty}</div>;
  return (
    <div className="table-wrap">
      <table className="e360-table">
        <thead><tr>{cols.map(c => <th key={c.name} className={NUMERIC.includes(c.type) ? 'num' : ''}>{c.label}</th>)}</tr></thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id} className={onRow ? 'clickable' : ''} onClick={() => onRow?.(r)}>
              {cols.map(c => (
                <td key={c.name} className={NUMERIC.includes(c.type) ? 'num' : c.type === 'textarea' ? 'wrap' : ''}>
                  {c.pill ? <StatusPill value={c.get ? c.get(r) : r[c.name]} /> : c.render ? c.render(r) : fmtValue(c, r)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
